<template>
  <div class="loto">
    <SectionPickTabs />
    <Information />
  </div>
</template>

<script>
import SectionPickTabs from '@/views/pos/lotto/section-pick-tabs/index';
import Information from '@/views/pos/lotto/information';
export default {
  components: {
    SectionPickTabs,
    Information
  }
}
</script>
